export const QA_NAME_CALENDAR_ITEM_CARD_STEP = 'calendarItemCardStep'
